// 상점 관리 - 휴무일
// 요일 타입(days)
// https://qc-zoo-client-api.barogo.io/docs/common/days.html
import { i18n } from '@/locales';
export const MONDAY = 'MONDAY';
export const TUESDAY = 'TUESDAY';
export const WEDNESDAY = 'WEDNESDAY';
export const THURSDAY = 'THURSDAY';
export const FRIDAY = 'FRIDAY';
export const SATURDAY = 'SATURDAY';
export const SUNDAY = 'SUNDAY';
// eslint-disable-next-line import/prefer-default-export
export const weekTypeList = [
    MONDAY,
    TUESDAY,
    WEDNESDAY,
    THURSDAY,
    FRIDAY,
    SATURDAY,
    SUNDAY,
];
// {MONDAY: '월', TUESDAY: '화'...}
export const koWeekObject = weekTypeList.reduce((acc, it, index) => {
    acc[it] = i18n.t(`common.week_type_code.shorten_text[${index}]`);
    return acc;
}, {});
export const convertKoParser = (enWeek) => enWeek.map((en) => koWeekObject[en]);
/**
 * 빈 요일 데이터 생성
 */
export const createWeekObject = () => (weekTypeList.reduce((acc, it) => {
    acc[it] = {
        value: koWeekObject[it],
        isWork: false,
    };
    return acc;
}, {}));
